import React, { useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Chip,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

const CreateBattle = () => {
  const [characters, setCharacters] = useState([]);
  const [character, setCharacter] = useState("");

  const formik = useFormik({
    initialValues: {
      title: "",
      type: "single",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Required"),
      type: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      // Handle battle creation
      const battleData = {
        ...values,
        characters,
      };
      console.log(battleData);
    },
  });

  const handleAddCharacter = () => {
    if (character && characters.length < 4) {
      setCharacters([...characters, character]);
      setCharacter("");
    }
  };

  const handleRemoveCharacter = (index) => {
    setCharacters(characters.filter((_, i) => i !== index));
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Create New Battle
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Box component="form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="title"
                  name="title"
                  label="Battle Title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  error={formik.touched.title && Boolean(formik.errors.title)}
                  helperText={formik.touched.title && formik.errors.title}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Battle Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type"
                    name="type"
                    value={formik.values.type}
                    label="Battle Type"
                    onChange={formik.handleChange}
                  >
                    <MenuItem value="single">Single Battle</MenuItem>
                    <MenuItem value="tournament">Tournament</MenuItem>
                    <MenuItem value="deathmatch">Deathmatch</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mb: 2 }}>
                  <TextField
                    fullWidth
                    label="Add Character"
                    value={character}
                    onChange={(e) => setCharacter(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddCharacter();
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={handleAddCharacter}
                    sx={{ mt: 1 }}
                    disabled={characters.length >= 4}
                  >
                    Add Character
                  </Button>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {characters.map((char, index) => (
                    <Chip
                      key={index}
                      label={char}
                      onDelete={() => handleRemoveCharacter(index)}
                    />
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={characters.length < 2}
                >
                  Create Battle
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default CreateBattle;
